export function buildCloudinaryUrl(url, opts = {}) {
  if (!url || typeof url !== 'string') return url || ''
  const u = url.trim()
  if (!u.includes('res.cloudinary.com') || !u.includes('/image/upload/')) return u
  const { w, h, crop, quality, blur, dprAuto = true } = opts
  const parts = u.split('/image/upload/')
  const prefix = parts[0]
  const suffix = parts[1] || ''
  const transforms = []
  transforms.push('f_auto')
  if (quality) {
    transforms.push(`q_${quality}`)
  } else {
    transforms.push('q_auto')
  }
  if (dprAuto) transforms.push('dpr_auto')
  if (w && Number(w) > 0) transforms.push(`w_${Math.round(Number(w))}`)
  if (h && Number(h) > 0) transforms.push(`h_${Math.round(Number(h))}`)
  if (h && w) {
    transforms.push(`c_${crop || 'fill'}`)
  } else if (w && !h) {
    transforms.push('c_limit')
  }
  if (blur) transforms.push(`e_blur:${Math.round(Number(blur))}`)
  const transformStr = transforms.join(',')
  return `${prefix}/image/upload/${transformStr}/${suffix}`
}

export function buildCloudinarySrcSet(url, widths = [], opts = {}) {
  if (!url) return ''
  const set = widths.map(w => `${buildCloudinaryUrl(url, { ...opts, w })} ${w}w`).join(', ')
  return set
}
